export const API_EXTERNAL_ENDPOINT = 'legal-owner-info-page'

export const API_INTERNAL_ENDPOINT = 'strapi/legal-owner-info-page'
